<template lang="pug">
GenericCard(size='40')
  .px-4.py-4
    .text-title อัพโหลดไฟล์ราคาและค่าคอม
  hr.m-0

  template(v-if='isSubmitted === false')
    .check-in.px-4.py-4
      //- .text-title.mb-2 Base Price
      CustomFileUpload.file-upload(
        v-model='newBaseFile'
        accept=".xls,.xlsx"
      )

    hr.m-0

    //- .check-in.px-4.py-4
    //-   .text-title.mb-2 Percentage Addition
    //-   CustomFileUpload.file-upload(
    //-     v-model='newPercentageFile'
    //-     accept=".xls,.xlsx"
    //-   )

    //- hr.m-0

    //- .check-in.px-4.py-4
    //-   .text-title.mb-2 Custom Price
    //-   CustomFileUpload.file-upload(
    //-     v-model='newCustomPriceFile'
    //-     accept=".xls,.xlsx"
    //-   )

    //- hr.m-0

    template(v-if='anyFileSelected === true')
      .check-in.bg-white.px-4.py-3()
        template(v-if='error')
          .alert.alert-danger {{ error }}
        button.btn.btn-upa-secondary.d-flex.align-items-center(
          @click='uploadFiles'
          :disabled='isUploading'
        )
          template(v-if='isUploading')
            LoadingIndicator(style='transform: scale(0.75); margin: -4px 0; ')
          template(v-else)
            | บันทึก

  template(v-else)
    .submitted.d-flex.flex-column
      .response-message
        img(src='@/assets/icons/success.svg')
        .text-large.mt-3
          | อัพโหลดไฟล์สำเร็จแล้ว
        .text-medium.mt-2
          | สินค้า
          | {{ success.affected }}
          | รายการได้รับการแก้ไข
        button.btn.btn-secondary.mt-4(@click='reset')
          | ตกลง

</template>

<script>
export default {
  props: {
    customer: {
      default: () => ({}),
    },
  },
  computed: {
    anyFileSelected() {
      return (
        this.definedAndHasValue(this.newBaseFile)
        // || this.definedAndHasValue(this.newPercentageFile)
        // || this.definedAndHasValue(this.newCustomPriceFile)
      );
    },
  },
  data: () => ({
    isUploading: false,
    isSubmitted: false,

    newBaseFile: null,
    // newPercentageFile: null,
    // newCustomPriceFile: null,

    error: null,
    success: {},
  }),
  methods: {
    definedAndHasValue(x) {
      return x !== undefined && x !== null && x !== '' && x !== {};
    },
    async uploadFiles() {
      this.isUploading = true;

      try {
        const formData = new FormData();
        formData.append('xlsx', this.newBaseFile);

        const res = await this.$api.product.uploadPriceFiles(formData);
        if (res.status === 200) {
          this.success = res.data;
        }
        console.log(res);

        this.isSubmitted = true;
      } catch (e) {
        // ...
        this.error = e;
      }

      this.isUploading = false;
    },

    reset() {
      this.isUploading = false;
      this.isSubmitted = false;

      this.newBaseFile = null;
      // this.newPercentageFile = null;
      // this.newCustomPriceFile = null;

      this.error = null;
      this.success = {};
    },
  },
};
</script>

<style lang="scss">
.check-in {
  background: #FAFAFA;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  // .check-in-img {
  //   width: 200px;
  //   height: 200px;
  //   background: #E0E0E0;
  // }

  .file-upload {
    max-width: 80%;
  }
}
.response-message {
  min-height: 360px;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
}
</style>
